import App from './App.svelte'

const app = new App({
  target: document.body,
  anchor: document.querySelector('.anchor')
})

export default app
